import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, RadioGroup, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const ConsentCustodyStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [intro, setIntro] = useState<string>('Vælg din rolle i forhold til forældremyndigheden.');
  const [title, setTitle] = useState<string>('Forældremyndighed');

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas_samtykke.consent_custody).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);

  const handleNext = () => {
    if (selfServiceData.consentCustodyType) {goNext();}
  };

  return (
    <StepContainer title={title}>
      <InfoBox type="info"><p>{intro}</p></InfoBox>
      <RadioGroup
        name="consentCustodyType"
        options={[
          { value: 'ene', label: 'Eneindehaver' },
          { value: 'med', label: 'Medindehaver' },
          { value: 'vaerge', label: 'Værge' },
          { value: 'anden', label: 'Anden' },
        ]}
        value={selfServiceData.consentCustodyType}
        onChange={(v) => updateSelfServiceData('consentCustodyType', v as any)}
        legend="Forældremyndighed"
        required
      />
      <NavigationButtons onBack={goBack} onNext={handleNext} nextDisabled={!selfServiceData.consentCustodyType} />
    </StepContainer>
  );
};

export default ConsentCustodyStep;
